// One date format for the whole software: DD/MM/YYYY (date-time: DD/MM/YYYY hh:mm AM/PM, India time).
const pad = (n) => String(n).padStart(2, '0');
const TZ = 'Asia/Kolkata';
const PLAIN = /^(\d{4})-(\d{2})-(\d{2})(?:[T ]00:00:00(?:\.0+)?)?$/;

function fromParts(d, m, y) { return `${pad(d)}/${pad(m)}/${y}`; }

/** 'YYYY-MM-DD' (or the same at 00:00 without a timezone) -> DD/MM/YYYY without any timezone shift;
 * a Date uses its local calendar day; a timestamp string (…Z / +05:30) is shown as the India date. */
export function formatDate(v, empty = '—') {
  if (v === null || v === undefined || v === '') return empty;
  if (v instanceof Date) {
    return Number.isNaN(v.getTime()) ? empty : fromParts(v.getDate(), v.getMonth() + 1, v.getFullYear());
  }
  const s = String(v).trim();
  const m = PLAIN.exec(s);
  if (m) return fromParts(m[3], m[2], m[1]);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return empty;
  return d.toLocaleDateString('en-GB', { timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function formatDateTime(v, empty = '—') {
  if (v === null || v === undefined || v === '') return empty;
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return empty;
  return d.toLocaleString('en-GB', {
    timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true,
  }).replace(',', '').replace(/\b(am|pm)\b/i, (x) => x.toUpperCase());
}

/** DD/MM/YYYY typed by a person -> 'YYYY-MM-DD' ('' when not a real date). */
export function parseDisplayDate(text) {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(text || ''));
  if (!m) return '';
  const d = Number(m[1]); const mo = Number(m[2]); const y = Number(m[3]);
  const t = new Date(y, mo - 1, d);
  if (t.getFullYear() !== y || t.getMonth() !== mo - 1 || t.getDate() !== d) return '';
  return `${m[3]}-${m[2]}-${m[1]}`;
}
